export default "__VITE_ASSET__DvSHEvY1__"